import en from 'antd/lib/locale/en_US';
import de from 'antd/lib/locale/de_DE';

export const getFormLang = (lang: string) => {
  switch (lang) {
    case 'en':
      return en;
    case 'de':
      return de;
    default:
      return en;
  }
};
